<template>
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          {{ttInterface.libInterface}}
        </p>
      </header>
      <div class="card-content">
        <div class="content">
          <ttbox-optionInterface :ttOptionInterface="option" :key="option.idOptionInterface" v-for="option in ttInterface.optionsInterfaces"></ttbox-optionInterface>
        </div>
      </div>
      <footer class="card-footer">
        <p class="card-footer-item">
          <ttbox-wifiSignal v-if="ttInterface.status!=null" :signal="ttInterface.status.signalWiFi" />
          <ttbox-wifiSignal v-if="ttInterface.status==null" :disabled="true" />
          <span v-if="ttInterface.status!=null && ttInterface.status.nbValeurAttente>0" class="tag is-warning">Lag: {{ttInterface.status.nbValeurAttente}}</span>
        </p>
      </footer>
    </div>
</template>

<script>
import OptionInterface from '../components/OptionInterface'
import WifiSingal from '../components/WiFiSignal'

export default {
  props : [
    'ttInterface'
  ],
  components: {
    'ttbox-optionInterface': OptionInterface,
    'ttbox-wifiSignal': WifiSingal
  }
}
</script>
